import { render, staticRenderFns } from "./RadioButtonChoice.vue?vue&type=template&id=4a653af7&scoped=true&"
import script from "./RadioButtonChoice.vue?vue&type=script&lang=js&"
export * from "./RadioButtonChoice.vue?vue&type=script&lang=js&"
import style0 from "./RadioButtonChoice.vue?vue&type=style&index=0&id=4a653af7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a653af7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VLayout,VListItem,VListItemContent,VRadio,VRadioGroup,VRow})
